"use client";

import { useEffect } from "react";

import { connectRealtime, disconnectRealtime } from "@/store/realtime";

/** Connects the shared realtime client when `VITE_WS_URL` is set. No UI. */
export function RealtimeBootstrap({ wsUrl }: { wsUrl: string | null }) {
  useEffect(() => {
    if (!wsUrl) {
      return;
    }
    connectRealtime(wsUrl);
    return () => {
      disconnectRealtime();
    };
  }, [wsUrl]);

  return null;
}
